<proffeo-ui-dialog [title]="'create-user-title' | translate">
  <form
    [formRoot]="form"
    [autocomplete]="false"
    class="flex flex-col w-full gap-4"
  >
    <proffeo-ui-input
      [formField]="form.email"
      label="placeholders.e-mail"
      prefixIcon="alternate_email"
      class="w-full"
    />

    <proffeo-ui-input
      (valueChange)="onPasswordChange($event)"
      [formField]="form.password"
      label="reset-password-new-password"
      prefixIcon="lock"
      type="password"
      autocomplete="new-password"
      class="w-full"
    />

    <proffeo-ui-input
      [formField]="form.passwordConfirm"
      label="reset-password-new-password-confirm"
      prefixIcon="lock"
      type="password"
      autocomplete="new-password"
      class="w-full"
    />

    <proffeo-ui-input
      [formField]="form.firstName"
      label="placeholders.first-name"
      prefixIcon="account_box"
      class="w-full"
    />

    <proffeo-ui-input
      [formField]="form.lastName"
      label="placeholders.last-name"
      prefixIcon="account_box"
      class="w-full"
    />

    <proffeo-ui-input
      [formField]="form.notes"
      label="placeholders.notes"
      prefixIcon="comment"
      class="w-full"
    />

    <proffeo-ui-input
      [formField]="form.address"
      label="placeholders.address"
      prefixIcon="location_on"
      class="w-full"
    />

    <proffeo-ui-input
      [formField]="form.phoneNumbers"
      label="placeholders.phone-number"
      prefixIcon="phone"
      class="w-full"
    />
  </form>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      (clicked)="saveUserData()"
      [disabled]="form().invalid() || form().submitting()"
      variant="accent"
      text="save-and-close"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
